import Api from './api';

const userBidGroupsRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/groups', {headers: { Authorization: 'Bearer ' + access_token }, params: query })
}

const userGroupSettingsRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/settings', {headers: { Authorization: 'Bearer ' + access_token }})
}

const userGroupUpdateRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/group/' + data.id, data, {headers: { Authorization: 'Bearer ' + access_token }})
}

const createGroupRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/group/', data, {headers: { Authorization: 'Bearer ' + access_token }})
}



export default { userBidGroupsRequest, userGroupSettingsRequest, userGroupUpdateRequest, createGroupRequest }



// WEBPACK FOOTER //
// ./src/api/apiGroups.js